module.exports = __webpack_public_path__ + "resources/triangle-2-efa848ed878b6c3e1552fddb057ca784.svg";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/triangle-2.svg
// module id = 75
// module chunks = 0